import { render } from "./Product.vue?vue&type=template&id=6db0515e"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=6db0515e&lang=scss"
script.render = render

export default script